import * as React from 'react';
import { Box, styled } from '@mui/material';
import { IPublicAndPrivateSettings } from '@pepperhq/location-sdk';
import Done from '@mui/icons-material/Done';
import Close from '@mui/icons-material/Close';

import { MuiCardForm } from 'lib/form/MuiCardForm';
import { SwitchFormField } from 'lib/form/fields/SwitchFormField';
import { SettingDisplay } from 'lib/SettingDisplay';

const PREFIX = 'PayAtPOSSettings';

const classes = {
    settingsCard: `${PREFIX}-settingsCard`,
    displayClassName: `${PREFIX}-displayClassName`
};

const StyledMuiCardForm = styled(MuiCardForm)(({ theme }) => ({
    [`&.${classes.settingsCard}`]: {
        marginBottom: theme.spacing(2)
    },
    [`& .${classes.displayClassName}`]: {
        padding: theme.spacing(2)
    }
}));

type IProps = {
    settings: IPublicAndPrivateSettings;
    onSubmit: (values: Record<string, any>) => Promise<boolean>;
};

export const PayAtPOSSettings = ({ settings, onSubmit }: IProps) => (
    <StyledMuiCardForm
        title="Pay At POS"
        initialValues={{
            payAtPosEnabled: settings?.payAtPosEnabled ?? false
        }}
        onSubmit={onSubmit}
        childrenWhileDisplaying={
            <Box display="flex" flexDirection="column">
                <SettingDisplay label="Pay At POS Enabled">
                    {settings?.payAtPosEnabled && <Done />}
                    {!settings?.payAtPosEnabled && <Close />}
                </SettingDisplay>
            </Box>
        }
        childrenWhileEditing={
            <Box display="flex" flexDirection="column">
                <SettingDisplay label="Pay At POS Enabled">
                    <SwitchFormField name="payAtPosEnabled" />
                </SettingDisplay>
            </Box>
        }
        className={classes.settingsCard}
        boxClassName={classes.displayClassName}
    />
);
